import React from "react";
import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";

const testimonials = [
  {
    name: "Aanya Mehta",
    role: "F-1 Student Visa · Stanford",
    img: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop",
    text: "The mock interview sessions were game-changing. They knew exactly what the consular officer would ask. Approved in 4 minutes flat.",
  },
  {
    name: "Rajat Khurana",
    role: "B1/B2 Visa · NYC Trip",
    img: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop",
    text: "Twice rejected before — Travel Factor fixed my DS-160, restructured my docs, and got me approved on the first attempt with them.",
  },
  {
    name: "Priya Iyer",
    role: "Europe Honeymoon Package",
    img: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&h=200&fit=crop",
    text: "Paris, Rome and Amsterdam in 11 days. Every transfer, every reservation handled. We just had to show up and live the dream.",
  },
  {
    name: "Vikram Singh",
    role: "L-1 Business Visa",
    img: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop",
    text: "Corporate paperwork is a nightmare. Their immigration counsel made it feel like a checklist. Approved in 18 days.",
  },
  {
    name: "Sneha Kapoor",
    role: "Dubai Family Tour",
    img: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=200&h=200&fit=crop",
    text: "Three generations, one trip, zero stress. The desert safari with private cabana was unforgettable.",
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="relative py-24 md:py-32 overflow-hidden bg-white">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 right-1/4 w-96 h-96 rounded-full opacity-20" style={{ background: "radial-gradient(circle, rgba(0,153,204,0.4), transparent 70%)", filter: "blur(60px)" }} />
        <div className="absolute bottom-0 left-1/4 w-96 h-96 rounded-full opacity-20" style={{ background: "radial-gradient(circle, rgba(212,175,55,0.4), transparent 70%)", filter: "blur(60px)" }} />
      </div>

      <div className="relative max-w-7xl mx-auto px-5 md:px-8">
        <div className="max-w-3xl mb-16">
          <div className="text-xs uppercase tracking-[0.3em] text-gold-dark font-semibold mb-4">— Voices Of Travellers</div>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tighter leading-[1.05] text-navy-deep">
            Stories from <span className="text-gradient-navy">approved</span> passports.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((t, i) => (
            <motion.div
              key={t.name}
              data-testid={`testimonial-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: i * 0.1, duration: 0.7 }}
              className={`relative bg-white rounded-3xl p-7 md:p-8 group hover:premium-shadow transition-all duration-500 border border-navy-deep/8 soft-shadow ${
                i === 1 ? "md:translate-y-8" : ""
              } ${i === 3 ? "lg:translate-y-8" : ""}`}
            >
              <Quote className="absolute top-6 right-6 w-9 h-9 text-sky-brand/20" />
              <div className="flex items-center gap-1 mb-5">
                {[...Array(5)].map((_, k) => (
                  <Star key={k} className="w-3.5 h-3.5 fill-gold text-gold" />
                ))}
              </div>
              <p className="text-slate-700 leading-relaxed text-[15px] mb-7">{t.text}</p>
              <div className="flex items-center gap-3.5 pt-5 border-t border-navy-deep/8">
                <img src={t.img} alt={t.name} className="w-11 h-11 rounded-full object-cover border-2 border-white shadow-md" />
                <div>
                  <div className="font-semibold text-sm text-navy-deep">{t.name}</div>
                  <div className="text-xs text-slate-500 mt-0.5">{t.role}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
